
import { api, baseUrl,  } from '../../api';

export const getAllinventoryApi = async (locationCode: any) => {
    const result = await api.get(`${baseUrl}/admin/external-api/inventoryMovement?Location_Filter='${locationCode}'`);
    return result;
};